export default "__VITE_ASSET__a5123c11__"